import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Single source of truth for feel. Editorial motion: firm, unhurried, no bounce.
export const EASE = "power3.out";
export const EASE_IN_OUT = "power2.inOut";

/** Honour the OS setting and small screens. Heavy scrub work is desktop-only. */
export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const isCoarsePointer = () =>
  typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;

/** True when we're allowed to run the expensive pinned/scrubbed set-pieces. */
export const canAnimateHeavy = () =>
  !prefersReducedMotion() && typeof window !== "undefined" && window.innerWidth >= 1024;

/* ScrollTrigger measures before webfonts land, and every headline moves when
   they do. SmoothScroll used to re-measure once on document.fonts.ready; it no
   longer runs (CMD_01), so the single global refresh lives here instead. */
if (typeof document !== "undefined" && document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => ScrollTrigger.refresh());
}

export { gsap, ScrollTrigger };
